export default {
    thumb: 'تصویر',
    name: 'نام',
    description: 'توضیحات',
    action: 'عملیات',
    noImage: 'تصویری موجود نیست',
    noFile: 'فایلی موجود نیست',
    addAFile: 'افزودن فایل',

}